import React from "react";
import type ConsumerTemplate from "../models/DrawingItemTemplate";
import type DeviceTemplate from "../models/DeviceTemplate";
import Browser from "../browser";

export default function ConsumerTemplateView(props: {
  template: ConsumerTemplate | DeviceTemplate;
  disabled: boolean;
}) {
  const { template, disabled } = props;

  var imageStyle: any = {
    width: "auto",
    height: `25px`, // `calc(100% - ${hText})`,
    objectFit: "contain",
    fontSize: "25px",
  };

  function ImageElement(props: { srcImage: string }) {
    const { srcImage } = props;
    if (srcImage.startsWith("lab") || srcImage.startsWith("las")) {
      return <i className={srcImage} draggable="false" style={imageStyle} />;
    }
    return (
      <img
        draggable="false" // no itx
        style={imageStyle}
        src={template.image}
      />
    );
  }

  if (disabled) {
    imageStyle.filter = "opacity(0.3)"; // no itx
  }

  let name = (template as ConsumerTemplate).titleShort;

  const flyoutActive = true;
  let hint = `${state.translate(
    "consumerTemplateView.symbolsOnRoomplan",
    `Diese Symbole können auf einem Raumplan plaziert werden.<br/>`,
  )}  <i class="las la-edit"></i>`;
  // let hint = `Diese Symbole können auf einem Raumplan plaziert werden.<br/>`;
  // hint += `Dieser muss zuvor geöffnet werden<br/>`;
  // hint += `Kicke am Raum auf:  <i class="las la-edit"></i>`;

  return (
    <div
      key={template.name}
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        pointerEvents: "auto",
        justifyContent: "center",
      }}
      className="consumerTemplate"
      data-tooltip-id={disabled ? "tv-tooltip" : ""}
      data-tooltip-html={disabled ? hint : undefined} //  `${(template as any).titleShort}`}
      data-tooltip-place={Browser.isMobile() ? "bottom-start" : "left"} // no itx
    >
      <div className="description">{name}</div>

      <ImageElement srcImage={template.image} />
    </div>
  );
}
export function RoomTemplateView(props: { template: ConsumerTemplate | DeviceTemplate; disabled: boolean }) {
  const { template, disabled } = props;

  let name = (template as ConsumerTemplate).titleShort;

  return (
    <div
      key={template.name}
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        pointerEvents: "auto",
        justifyContent: "center",
      }}
      className="roomTemplate"
    >
      <div className="">{name}</div>
      <i className="lab la-codepen" style={{ fontSize: "20px" }} />
    </div>
  );
}
